import { render, staticRenderFns } from "./healthView.vue?vue&type=template&id=449c2446&scoped=true"
import script from "./healthView.vue?vue&type=script&lang=js"
export * from "./healthView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c2446",
  null
  
)

export default component.exports